import type { ComponentMeta } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { LayoutBlock } from "@/react/components/shared/BuilderUI/constants/BlockCategories";

export const meta: ComponentMeta = {
  name: "Paragraph",
  version: 1,
  nameI18n: "builder_ui.block_type.form_paragraph",
  category: [LayoutBlock],
  props: {
    value: {
      name: "Text",
      nameI18n: "builder_ui.prop_type.text",
      prop: "other",
      type: "string",
    },
  },
};
